import React from 'react'

const BodyText1 = (props: any) => <p {...props} className="kogan-text-body1" />

export default BodyText1
